import { __assign, __rest } from "tslib";
import React from 'react';
import { twMerge } from 'tailwind-merge';
var SidebarContainer = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({}, rest, { className: twMerge('row-start-1 row-end-3 col-span-1', className) }), children));
};
export default SidebarContainer;
